import type {EmbeddedDashboardView} from "~/pages/chat-agent/types/chatTypes";

/**
 * Identity of an embedded dashboard's current state: changes when the agent switches dashboards or
 * edits the current one (same embed uuid, new refreshToken). Used as the SupersetDashboardPanel key,
 * so the iframe reloads with the new charts.
 */
export const embeddedDashboardKey = (dashboard: EmbeddedDashboardView) =>
    `${dashboard.uuid}:${dashboard.refreshToken}`;
